export default __webpack_public_path__ + "static/media/ico-sorrisos.afee759a.svg";